import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import promise from 'redux-promise-middleware';
import makeRootReducer from "./reducers";

export default (initialState = {}) => {

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const composeEnhancers =
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
          window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
          }) : compose;

  const store = createStore(makeRootReducer({}), initialState, composeEnhancers(
    applyMiddleware(thunk, promise),
  ));

  // const store = createStore(
  //   makeRootReducer({}),
  //   initialState,
  //   applyMiddleware(thunk, promise),
  //   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  // );

  store.asyncReducers = {};
  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const makeRootReducer = require("./reducers").default;
      store.replaceReducer(makeRootReducer(store.asyncReducers));
    });
  }
  return store;
};
